/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Role1Inputs */

const en_formfields_role1 = /** @type {(inputs: Formfields_Role1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Formfields_Role1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_role1 = /** @type {((inputs?: Formfields_Role1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Role1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_role1(inputs)
});
export { formfields_role1 as "formFields_role" }